import { createContext, PropsWithChildren, useContext } from 'react';

import { ResourceType } from '@dbt-labs/dbt-dag';

export interface ResourceInfo {
  resourceIdentifiers?: string[];
  resourceType: ResourceType;
  name?: string | null;
  filePath?: string | null;
  latestGitSha?: string | null;
}

const ResourceInfoContext = createContext<ResourceInfo>({
  resourceIdentifiers: [],
  resourceType: 'model',
  name: null,
  filePath: null,
  latestGitSha: null,
});

export const useResourceInfo = () => {
  return useContext(ResourceInfoContext);
};

/**
 * This provider is used to pass resource information to deeply nested components.
 */
export const ResourceInfoProvider: React.FC<
  PropsWithChildren<{
    resourceIdentifiers?: string[];
    resourceType: ResourceType;
    name?: string | null;
    filePath?: string | null;
    latestGitSha?: string | null;
  }>
> = ({ children, resourceIdentifiers, resourceType, name, filePath, latestGitSha }) => {
  const resourceInfo: ResourceInfo = {
    resourceIdentifiers,
    name,
    resourceType,
    filePath,
    latestGitSha,
  };

  return (
    <ResourceInfoContext.Provider value={resourceInfo}>
      {children}
    </ResourceInfoContext.Provider>
  );
};
